/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["#actions[_ngcontent-%COMP%]   clr-dropdown[_ngcontent-%COMP%]{float:right}.dropdown-toggle[_ngcontent-%COMP%]   clr-icon[_ngcontent-%COMP%]{margin-top:9px}"];
export { styles as styles };

